export const organizationSettingsConstants = {
    GET_DATA_SOURCE_HANDLE_INFO_FETCH_REQUEST: 'GET_DATA_SOURCE_HANDLE_INFO_FETCH_REQUEST',
    GET_DATA_SOURCE_HANDLE_INFO_REFRESH_REQUEST: 'GET_DATA_SOURCE_HANDLE_INFO_REFRESH_REQUEST',
    GET_DATA_SOURCE_HANDLE_INFO_SUCCESS: 'GET_DATA_SOURCE_HANDLE_INFO_SUCCESS',
    GET_DATA_SOURCE_HANDLE_INFO_FAILURE: 'GET_DATA_SOURCE_HANDLE_INFO_FAILURE',

    GET_TRENDS_DATA_SOURCE_HANDLES_REQUEST: 'GET_TRENDS_DATA_SOURCE_HANDLES_REQUEST',
    GET_TRENDS_DATA_SOURCE_HANDLES_SUCCESS: 'GET_TRENDS_DATA_SOURCE_HANDLES_SUCCESS',
    GET_TRENDS_DATA_SOURCE_HANDLES_FAILURE: 'GET_TRENDS_DATA_SOURCE_HANDLES_FAILURE',

    GET_AUTO_ACTIONS_INFO_FETCH_REQUEST: 'GET_AUTO_ACTIONS_INFO_FETCH_REQUEST',
    GET_AUTO_ACTIONS_INFO_REFRESH_REQUEST: 'GET_AUTO_ACTIONS_INFO_REFRESH_REQUEST',
    GET_AUTO_ACTIONS_INFO_SUCCESS: 'GET_AUTO_ACTIONS_INFO_SUCCESS',
    GET_AUTO_ACTIONS_INFO_FAILURE: 'GET_AUTO_ACTIONS_INFO_FAILURE',

    GET_ORGANIZATION_INFO_REQUEST: 'GET_ORGANIZATION_INFO_REQUEST',
    GET_ORGANIZATION_INFO_SUCCESS: 'GET_ORGANIZATION_INFO_SUCCESS',
    GET_ORGANIZATION_INFO_FAILURE: 'GET_ORGANIZATION_INFO_FAILURE',

    GET_TRENDS_ORGANIZATION_REQUEST: 'GET_TRENDS_ORGANIZATION_REQUEST',
    GET_TRENDS_ORGANIZATION_SUCCESS: 'GET_TRENDS_ORGANIZATION_SUCCESS',
    GET_TRENDS_ORGANIZATION_FAILURE: 'GET_TRENDS_ORGANIZATION_FAILURE',

    UPDATE_TRENDS_ORGANIZATION_SETTING_REQUEST: 'UPDATE_TRENDS_ORGANIZATION_SETTING_REQUEST',
    UPDATE_TRENDS_ORGANIZATION_SETTING_SUCCESS: 'UPDATE_TRENDS_ORGANIZATION_SETTING_SUCCESS',
    UPDATE_TRENDS_ORGANIZATION_SETTING_FAILURE: 'UPDATE_TRENDS_ORGANIZATION_SETTING_FAILURE',

    GET_ORGANIZATION_CSM_LIST_REQUEST: 'GET_ORGANIZATION_CSM_LIST_REQUEST',
    GET_ORGANIZATION_CSM_LIST_SUCCESS: 'GET_ORGANIZATION_CSM_LIST_SUCCESS',
    GET_ORGANIZATION_CSM_LIST_FAILURE: 'GET_ORGANIZATION_CSM_LIST_FAILURE',

    UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST: 'UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST',
    UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS: 'UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS',
    UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE: 'UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE',

    UPDATE_TICKET_BUDGET_REQUEST: 'UPDATE_TICKET_BUDGET_REQUEST',
    UPDATE_TICKET_BUDGET_SUCCESS: 'UPDATE_TICKET_BUDGET_SUCCESS',
    UPDATE_TICKET_BUDGET_FAILURE: 'UPDATE_TICKET_BUDGET_FAILURE',

    GET_MSG_DATA_SOURCES_REQUEST: 'GET_MSG_DATA_SOURCES_REQUEST',
    GET_MSG_DATA_SOURCES_SUCCESS: 'GET_MSG_DATA_SOURCES_SUCCESS',
    GET_MSG_DATA_SOURCES_FAILURE: 'GET_MSG_DATA_SOURCES_FAILURE',

    GET_ORGANIZATION_DISABLE_PROCESSES_REQUEST: 'GET_ORGANIZATION_DISABLE_PROCESSES_REQUEST',
    GET_ORGANIZATION_DISABLE_PROCESSES_SUCCESS: 'GET_ORGANIZATION_DISABLE_PROCESSES_SUCCESS',
    GET_ORGANIZATION_DISABLE_PROCESSES_FAILURE: 'GET_ORGANIZATION_DISABLE_PROCESSES_FAILURE',

    INITIATE_ORGANIZATION_DISABLE_PROCESS_REQUEST: 'INITIATE_ORGANIZATION_DISABLE_PROCESS_REQUEST',
    INITIATE_ORGANIZATION_DISABLE_PROCESS_SUCCESS: 'INITIATE_ORGANIZATION_DISABLE_PROCESS_SUCCESS',
    INITIATE_ORGANIZATION_DISABLE_PROCESS_FAILURE: 'INITIATE_ORGANIZATION_DISABLE_PROCESS_FAILURE',

    GET_ORGANIZATION_REMOVE_PROCESSES_REQUEST: 'GET_ORGANIZATION_REMOVE_PROCESSES_REQUEST',
    GET_ORGANIZATION_REMOVE_PROCESSES_SUCCESS: 'GET_ORGANIZATION_REMOVE_PROCESSES_SUCCESS',
    GET_ORGANIZATION_REMOVE_PROCESSES_FAILURE: 'GET_ORGANIZATION_REMOVE_PROCESSES_FAILURE',

    INITIATE_ORGANIZATION_REMOVE_PROCESS_REQUEST: 'INITIATE_ORGANIZATION_REMOVE_PROCESS_REQUEST',
    INITIATE_ORGANIZATION_REMOVE_PROCESS_SUCCESS: 'INITIATE_ORGANIZATION_REMOVE_PROCESS_SUCCESS',
    INITIATE_ORGANIZATION_REMOVE_PROCESS_FAILURE: 'INITIATE_ORGANIZATION_REMOVE_PROCESS_FAILURE',

    GET_ORGANIZATION_CSM_LIST_REQUEST: 'GET_ORGANIZATION_CSM_LIST_REQUEST',
    GET_ORGANIZATION_CSM_LIST_SUCCESS: 'GET_ORGANIZATION_CSM_LIST_SUCCESS',
    GET_ORGANIZATION_CSM_LIST_FAILURE: 'GET_ORGANIZATION_CSM_LIST_FAILURE',

    UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST: 'UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST',
    UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS: 'UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS',
    UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE: 'UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE',

    UPDATE_TICKET_BUDGET_REQUEST: 'UPDATE_TICKET_BUDGET_REQUEST',
    UPDATE_TICKET_BUDGET_SUCCESS: 'UPDATE_TICKET_BUDGET_SUCCESS',
    UPDATE_TICKET_BUDGET_FAILURE: 'UPDATE_TICKET_BUDGET_FAILURE',
}
